module.exports = __webpack_public_path__ + "static/img/notice4.0e358f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice4.png
// module id = DApa
// module chunks = 2